export default "__VITE_ASSET__kXdvtG2c__"